import { AMLA_CODE_PREFIX, SCREENING_CODE_PREFIX } from '@/constants';
import { HomeAPIPath, HomeType } from '@/enums';
import { getRoute } from '@/hooks/useRouteSection';
import axios from 'axios';
import { navigate } from 'gatsby';

const urlPrefix =
  process.env.NODE_ENV !== 'development' ? process.env.api_url : '';

const axiosInterceptorInstance = axios.create({
  baseURL: urlPrefix,
});

// eslint-disable-next-line complexity
const handleServerError = (response: any) => {
  if (
    response.config.url !==
      '/screening/?relativeUrl=MDMScreening/GetCustomerProfileFE' &&
    response.status >= 500
  ) {
    redirectToErrorPage();
  }
};

const handleServerResponse = (response: any) => {
  // make dynamic endpoint
  const { countryCode, productType } = getRoute(window.location.pathname);

  const apiPath =
    productType === HomeType.Hohh ? HomeAPIPath.Hohh : HomeAPIPath.MyRumah;

  if (!response.data.succeeded) {
    if (
      response.config.url ===
        `/application/?countryCode=${countryCode}&relativeUrl=${apiPath}/CreateProposal` ||
      response.config.url ===
        `/quote/?countryCode=${countryCode}&relativeUrl=${apiPath}/CalculatePremium`
    ) {
      handleErrorCode(response);
    }
  }
};

const handleErrorCode = (response: any) => {
  const [codePrefix] = [...AMLA_CODE_PREFIX, SCREENING_CODE_PREFIX]
    .filter((codePrefix) => response.data.message.startsWith(codePrefix));

  if (codePrefix) {
    const errorCode = response.data.message.substring(0, codePrefix.length + 3);
    redirectToErrorPage(errorCode);
    return response;
  }

  redirectToErrorPage();
};

const redirectToErrorPage = (errorCode: string = '') => {
  if (typeof window !== 'undefined') {
    const { countryCode, productType, entity } = getRoute(
      window.location.pathname,
    );
    const errorPath = `/${countryCode}/${productType}/${entity}/error?code=${errorCode}`;
    navigate(errorPath);
  }
};

axiosInterceptorInstance.interceptors.response.use(
  (response) => {
    handleServerResponse(response);
    return response;
  },
  (error) => {
    const response = error.response;
    handleServerError(response);
  },
);

// Add a request interceptor to modify the URL before the request is sent
axiosInterceptorInstance.interceptors.request.use(
  function (config) {
    const { countryCode } = getRoute(window.location.pathname);
    // eslint-disable-next-line eqeqeq
    const index = config.url?.indexOf('?');
    if (index !== undefined) {
      if (index !== -1) {
        config.url =
          config.url?.slice(0, index + 1) +
          'countryCode=' +
          countryCode +
          '&' +
          config.url?.slice(index + 1);
      }
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

export default axiosInterceptorInstance;
